<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateOrdersView from "@/components/create-orders/createOrdersView.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Create Order",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, CreateOrdersView },
    data() {
        return {
            title: "Create Order",
            items: [
                {
                    text: "Utility",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <CreateOrdersView />
    </Layout>
</template>
